<div class="success-stories" *ngIf="successStories.length && !isMobile">
  <div class="top-heading">
    <h2>{{info.title}}</h2>
  </div>
  <div class="card-wrapper">
    <div class="swiper-container" [swiper]="config">
      <div class="swiper-wrapper">
        <div class="succes-stories-box-wrapper swiper-slide" *ngFor="let story of successStories" > 
          <div class="succes-stories-box" >
            <div class="story-image">
              <img loading="lazy" [attr.data-src]="getBannerImage(story)" class="" [alt]="story?.title"/>
            </div>
            <div class="story-content-wrapper">
              <div class="story-content">
                <h2>{{story?.title}}</h2>
                <p class="content">{{story?.descr}}</p>
                <div class="read-more"><a [href]="story.action">Read more</a></div>
              </div>
              <div class="bottom-content">
                <div class="hr"></div>
                <div class="whatsapp-wrapper">
                  <div class="text-content">
                    Subscribe to read such inspiring stories 
                  </div>
                  <div class="subscribe-btn-wrapper">
                    <a [href]="'https://api.whatsapp.com/send?phone=91' + variablesService.contactUsMobNumber+ '&text=Count%20me%20in%21%20I%20want%20to%20subscribe%20to%20Ketto%20Voice.'" class="whatsapp-btn" target="_blank">
                      <span class="icon-whatsapp"></span>Subscribe
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="success-stories" *ngIf="isMobile">
  <div class="top-heading">
    <h2>{{info.title}}</h2>
  </div>
  <div class="card-wrapper">
    <div class="swiper-container" [swiper]="config">
      <div class="swiper-wrapper">
        <div class="succes-stories-mob swiper-slide" *ngFor="let story of successStories">
          <a [href]="story.action">
            <div class="story-image">
              <img [attr.data-src]="getBannerImage(story)" class="" [alt]="story?.title"/>
            </div>
            <div class="story-content-wrapper">
              <div class="quote-wrapper">
                <img loading="lazy" data-src="/assets/images/home-v2/inverted-commas.svg" />
              </div>
              <h2 class="title">
                {{story.title}}
              </h2>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="create-impact-btn-wrapper">
    <button mat-button class="btn" (click)="routeToBrowseFundraiser()">
      <div class="text"> {{info.createImpactBtnLabel}}</div>
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
  <div class="bg-circle"></div>
</div>